import type { EntityActivitySource } from 'types/api-responses';
import type { EntityType } from './types';

export const ENTITY_TYPE_ITEMS: EntityType[] = [
  'Individual',
  'Organization',
  'Imported',
];

// Keyed by the source union, so a source without a label won't compile. One
// map, so a source reads the same in the library analytics aggregate and in
// the admin clean-up log's drill-down.
export const ACTIVITY_SOURCE_LABEL: Record<EntityActivitySource, string> = {
  document_ingest: 'Document ingest',
  manual_add: 'Manual add',
  add_as_new: 'Add as New',
  deduplicate: 'Deduplicate',
  bulk_deduplicate: 'Bulk deduplicate',
  reconcile_entity_page: 'Reconcile — entity page',
  reconcile_document: 'Reconcile — document structuring',
  mark_as_correct: 'Mark as Correct',
  direct_alias: 'Direct alias (entity page)',
  operator_feed: 'Operator feed',
};
